export default "__VITE_ASSET__DZuC42D$__"